import React, {useState, useEffect} from "react";
import {Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Avatar, DatePicker, Tag} from "antd";
import {Link} from "react-router-dom";
import Select from "react-select";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {formatDuration, intervalToDuration} from "date-fns";
import {ptBR} from "date-fns/locale";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import CustomPagination from "../util/CustomPagination";
import DashboardTopCards from "../dashboard/DashboardTopCards";
import UsersSearch from "../dashboard/calender/UsersSearch";
import "./assets/css/Lead.css";
import AuthService from "../login/AuthService";
import LeadTopCards from "./LeadTopCards";


const {RangePicker} = DatePicker;

const Lead = () => {
    document.title = "Leads | Plantão Rápido";


    const statusOptions = [
        {value: 'pending', label: 'Pendente'},
        {value: 'processing', label: 'Processando'},
        {value: 'sent', label: 'Enviado'},
        {value: 'clicked', label: 'Clicado'},
        {value: 'failed', label: 'Falhou'},
        {value: 'canceled', label: 'Cancelado'}
    ];
    const [loading, setLoading] = useState(true);
    const [loadingPage, setLoadingPage] = useState(false);
    const [filters, setFilters] = useState({
        dateRange: [],
        datestart: null,
        dateend: null,
        status: null,
        company: null,
    });


    const [pagination, setPagination] = useState({current: 0, pageSize: 10, total: 0, lastPage: 0});
    const [duties, setDuties] = useState([]);


    const fetchAllExtract = async (page = 1, isExport = false) => {
        try {
            setLoadingPage(true);
            const responseType = isExport ? 'blob' : 'json';

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}leads/list`,
                {
                    pagination: pagination.pageSize,
                    page: page,
                    status: filters?.status,
                    datestart: filters?.datestart,
                    dateend: filters?.dateend,
                    isExport
                },
                true,
                responseType
            );

            if (isExport) {
                // Processa exportação de arquivo
                const blob = new Blob([response], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = `export_${new Date().toISOString().split("T")[0]}.xlsx`;
                link.click();
                URL.revokeObjectURL(downloadUrl);
            } else {
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);


                setDuties(data || []);
                setLoadingPage(false);
                setPagination(pagInfo);
                setLoading(false);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };

    const handleClearFilters = () => {
        setFilters({
            dateRange: [],
            datestart: null,
            dateend: null,
            user_id: null,  // Usa null para limpar selects
        });

    };

    const handleSearchFiltersChange = (key, value) => {

        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    useEffect(() => {
        fetchAllExtract();
    }, []);


    const handleSendAndRemove = (index) => {
        const token = duties[index].token;

        // Abre o WhatsApp em nova aba
        window.open(`${process.env.REACT_APP_URL_API}leads/send-whatsapp/${token}`, '_blank');

        // Atualiza os leads removendo o item pelo índice
        setDuties((prev) => {
            const updated = prev.filter((_, i) => i !== index);

            // Se os leads acabaram, busca novamente
            if (updated.length === 0) {
                fetchAllExtract();
            }

            return updated;
        });
    };

    return (

        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Lead" pageTitle="Marketing"/>
                    <Row>
                        {loadingPage && <LoadingScreen/>}
                        <LeadTopCards/>


                        <div className="row mt-12 mb-12">

                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Situação</label>
                                    <Select
                                        id="statusSelect"
                                        classNamePrefix="react-select"
                                        options={statusOptions}
                                        value={statusOptions.find(opt => opt.value === filters.status) || null}
                                        placeholder="Selecione..."
                                        onChange={(selectedOption) =>
                                            handleSearchFiltersChange('status', selectedOption ? selectedOption.value : null)
                                        }
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999
                                            }),
                                            menu: base => ({...base, zIndex: 9999})
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Data Cadastro</label>
                                    <div className="form-control">
                                        <RangePicker
                                            style={{border: "none", boxShadow: "none"}}
                                            variant="outlined"
                                            locale={locale}
                                            format="DD/MM/YYYY"  // Mostra em DD/MM/YYYY na tela
                                            className="range-picker-custom"
                                            value={filters.dateRange.length > 0 ? filters.dateRange : null}
                                            onChange={(dates) => {
                                                if (dates) {
                                                    handleSearchFiltersChange("dateRange", dates);
                                                    handleSearchFiltersChange("datestart", dayjs(dates[0]).format("YYYY-MM-DD"));
                                                    handleSearchFiltersChange("dateend", dayjs(dates[1]).format("YYYY-MM-DD"));
                                                } else {
                                                    handleSearchFiltersChange("dateRange", []);
                                                    handleSearchFiltersChange("datestart", null);
                                                    handleSearchFiltersChange("dateend", null);
                                                }
                                            }}
                                        />

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row mt-4">
                            <div className="col-md-12 d-flex justify-content-end">

                                <button type="button" className="btn  mr-1  me-2"
                                        onClick={() => handleClearFilters()}>
                                    <i className="fa fa-eraser"></i> Limpar Filtros
                                </button>


                                {/*<button type="button" className="btn btn-dark mr-1  me-2"*/}
                                {/*        onClick={() => fetchAllExtract(1, true)}>*/}
                                {/*    <i className="fa fa-download"></i> Exportar*/}
                                {/*</button>*/}

                                <button type="button" className="btn btn-success"
                                        onClick={() => fetchAllExtract(1, false)}>
                                    <i className="fa fa-search"></i> Buscar
                                </button>
                            </div>
                        </div>


                        <div className="extract-list mt-3">
                            {loading ? (
                                <Skeleton count={5} height={80}/>
                            ) : duties.length > 0 ? (
                                duties.map((lead, index ) => (
                                    <div className="extract-item card  shadow-sm" key={lead.id}>
                                        <div className="row col-12">
                                            {/* Coluna esquerda */}
                                            <div className="col-md-6">

                                                {lead.email && (
                                                    <h5 className="mb-2 text-primary">
                                                        <i className="fa fa-envelope me-2"></i> {lead.email}
                                                    </h5>
                                                )}
                                                <p className="mb-1">
                                                    <strong>Nome:</strong> {lead.nome || 'Não informado'}
                                                </p>

                                                <p className="mb-1">
                                                    <strong>Telefone:</strong>{" "}
                                                    {lead.phone ? (
                                                        <button
                                                            href={`${process.env.REACT_APP_URL_API}leads/send-whatsapp/${lead.token}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-sm btn-success ms-1"
                                                            onClick={() => handleSendAndRemove(index)}
                                                        >
                                                            <i className="fab fa-whatsapp me-1"></i> Enviar WhatsApp
                                                            Campanha
                                                        </button>
                                                    ) : (
                                                        'Não informado'
                                                    )}
                                                </p>

                                                <p className="mb-1">
                                                    <strong>Cidade/UF:</strong> {lead.cidade || 'Não informado'} / {lead.uf || '--'}
                                                </p>
                                            </div>

                                            {/* Coluna direita */}
                                            <div className="col-md-6">
                                                <p className="mb-1">
                                                    <strong>Observações:</strong> {lead.observation || '—'}
                                                </p>

                                                {lead.campaign_sends?.length > 0 && (
                                                    <div className="mt-2">
                                                        <strong>Campanhas:</strong>
                                                        {lead.campaign_sends.map((send, index) => (
                                                            <div key={send.id || index} className="mb-1">
                                                                <Tag color="blue"
                                                                     className="me-2 text-uppercase">{send.status}</Tag>
                                                                {send.campaign?.name && (
                                                                    <span>
                                                                        Campanha: <strong>{send.campaign.name}</strong>
                                                                      </span>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                ))

                            ) : (
                                <div className="alert alert-primary mt-3" role="alert">Nenhum lead encontrado.</div>
                            )}
                        </div>
                        <CustomPagination
                            className="mt-4"
                            pagination={pagination}
                            onChange={(page) => fetchAllExtract(page, false)}
                        />

                    </Row>
                </Container>
            </div>
        </React.Fragment>


    )
        ;
};

export default Lead;
